import { computed } from '@ember/object';
export default function notEqual(property, value) {
  return computed(property, function () {
    return this.get(property) !== value;
  });
}